import { Type } from 'typebox';
import { Absence } from '../attendance/absence.js';
import { Checkpoint } from '../attendance/checkpoint.js';
import { Schedule } from '../attendance/schedule.js';
export const Trackable = Type.Object({
    homeroomKey: Type.Optional(Type.String({ minLength: 1 })),
    groupKey: Type.Optional(Type.String({ minLength: 1 })),
    locationKey: Type.Optional(Type.String({ minLength: 1 })),
    lastCheckpoint: Type.Optional(Checkpoint),
    schedule: Type.Optional(Schedule),
    scheduledAbsences: Type.Optional(Type.Array(Absence))
});
